import { render, staticRenderFns } from "./ButtonChowNow.vue?vue&type=template&id=3ea98df2"
import script from "./ButtonChowNow.vue?vue&type=script&lang=js"
export * from "./ButtonChowNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports